export enum ButtonType {
  primary = "primary",
  secondary = "secondary",
  inverse = "inverse",
}

export enum ButtonSize {
  sm = "sm",
  default = "default",
}

export type ButtonSizes = keyof typeof ButtonSize;
export type ButtonTypes = keyof typeof ButtonType;

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  buttonType: ButtonTypes;
  size?: ButtonSizes;
  icon?: React.ReactNode;
  isLoading?: boolean;
  /**
   * Responsive props which will override the default props at the "md" (768px) breakpoint
   * @example <Button size="sm" md={{ size: "default" }} />
   * will be the "sm" until 768px and the "default" from 768px and up
   */
  md?: {
    size?: ButtonSizes;
  };
};
